export const activityVerbs = {
  ISSUE_CREATE: "quality-issue-create",
  ISSUE_OPEN: "quality-issue-open",
  ISSUE_DRAFT: "quality-issue-draft",
  ISSUE_IN_PROGRESS: "quality-issue-in-progress",
  ISSUE_COMPLETED: "quality-issue-completed",
  ISSUE_NOT_APPROVED: "quality-issue-not-approved",
  ISSUE_IN_DISPUTE: "quality-issue-in-dispute",
  ISSUE_CLOSED: "quality-issue-closed",
  ISSUE_PENDING: "quality-issue-pending",
  ISSUE_IN_REVIEW: "quality-issue-in-review",
  ISSUE_EDIT: "quality-issue-edit",
  ISSUE_DUE_DATE: "quality-issue-due-date",
  ISSUE_ASSIGN: "quality-issue-assign",
  ISSUE_COMMENT: "quality-issue-comment",
  ISSUE_REFERENCE_ADDED: "issue-link-added",
  ISSUE_REFERENCE_REMOVED: "issue-link-removed",
  ISSUE_PLACEMENT_ADD: "issue-placement-add",
  ISSUE_PLACEMENT_REPOSITION: "issue-placement-reposition",
  ISSUE_PLACEMENT_REMOVE: "issue-placement-remove",
  ISSUE_DELETED: "quality-issue-deleted",
  ISSUE_RESTORED: "quality-issue-restored",
  ISSUE_SNAPSHOT_EDIT: "issue-snapshot-edit",
  ISSUE_ATTACHMENT_ADD: "issue-attachment-add",
  ISSUE_ATTACHMENT_REMOVE: "issue-attachment-remove",
  ISSUE_IMPORT_CREATE: "issue-import-create",
  ISSUE_IMPORT_EDIT: "issue-import-edit",
  ISSUE_SUGGESTION_GENERATED: "issue-suggestion-generated",
  ISSUE_COPY: "issue-copy",
} as const;

export type ActivityVerb = typeof activityVerbs[keyof typeof activityVerbs];

export enum activityChangeType {
  ChangedTitle = "changed_title",
  ChangedPublished = "changed_published",
  ChangedStatus = "changed_status",
  ChangedIssueType = "changed_issue_type_id",
  ChangedIssueSubtype = "changed_issue_subtype_id",
  ChangedDescription = "changed_description",
  ChangedAssignedTo = "changed_assigned_to",
  ChangedStartDate = "changed_start_date",
  ChangedDueDate = "changed_due_date",
  ChangedLocation = "changed_lbs_location",
  ChangedLocationDescription = "changed_location_description",
  ChangedBody = "changed_body",
  ChangedRootCause = "changed_root_cause_id",
  ChangedCustomAttributes = "changed_custom_attributes",
  /* in b360 it was called link but in acc it was changed to reference.
   * BE calls it link because b360 called it link, and they haven't kept up with the times 😅 */
  ChangedReference = "changed_link",
  ChangedWatchers = "changed_watchers",
  Placement = "placement",
  ChangedLinkedDocument = "changed_target_urn",
  IssueDeleted = "quality-issue-deleted",
  IssueRestored = "quality-issue-restored",
  ChangedSnapshot = "changed_snapshot",
  Attachment = "attachment",
  IssueSuggestionGenerated = "issue-suggestion-generated",
}

export const activityChangeTypes = [
  activityChangeType.ChangedTitle,
  activityChangeType.ChangedPublished,
  activityChangeType.ChangedStatus,
  activityChangeType.ChangedIssueType,
  activityChangeType.ChangedIssueSubtype,
  activityChangeType.ChangedDescription,
  activityChangeType.ChangedAssignedTo,
  activityChangeType.ChangedStartDate,
  activityChangeType.ChangedDueDate,
  activityChangeType.ChangedLocation,
  activityChangeType.ChangedLocationDescription,
  activityChangeType.ChangedBody,
  activityChangeType.ChangedRootCause,
  activityChangeType.ChangedCustomAttributes,
  activityChangeType.ChangedReference,
  activityChangeType.ChangedWatchers,
  activityChangeType.Placement,
  activityChangeType.ChangedLinkedDocument,
  activityChangeType.IssueDeleted,
  activityChangeType.IssueRestored,
  activityChangeType.ChangedSnapshot,
  activityChangeType.Attachment,
  activityChangeType.IssueSuggestionGenerated,
] as const;
